/* eslint-disable import/max-dependencies */
import type { FC } from "react";
import type React from "react";
import { Form } from "@fas/ui-core";
import { withForm } from "@fas/ui-framework";
import { LOGIN_FORM } from "@fas/cpa-state-manager/redux/constants";
import { Helmet } from "react-helmet";
import { Typography, Button } from "@mui/material";
import { EmailOutlined, LockOpenOutlined } from "@mui/icons-material";
import environment from "environment";
import { withState } from "@fas/cpa-cabinet-ui";
import TextField from "../TextFieldForm";
import AuthFormGrid from "../AuthFormGrid";
import { usePasswordField } from "../../hooks";
import schema from "./validation";
import { getValidation } from "../../utils";

const LoginForm = withForm(Form);
const PasswordField = withState(TextField, usePasswordField);
const typographySx = {
  mb: 4,
  textAlign: "center",
  minWidth: {
    sm: "max-content",
  },
};
const inputSx = {};
const btnSx = {
  mb: 1,
};

type Props = {
  isLoading: boolean;
  onKeyPress: (arg0: React.KeyboardEvent) => unknown;
  onSave: () => unknown;
};

const Login: FC<Props> = ({ isLoading, onKeyPress, onSave }) => (
  <>
    <Helmet>
      <title>
        Login
      </title>
      <meta
        name="description"
        content="Our Smartlink system will find the best offers to monetize 100% of your traffic. Earn from any traffic source and any traffic mix in any volume with one of the best CPA networks."
      />
    </Helmet>
    <LoginForm id={LOGIN_FORM} validate={getValidation(schema)} onSave={onSave}>
      <AuthFormGrid>
        <Typography variant="gradientH1" sx={typographySx}>
          Log In
        </Typography>
        <TextField
          name="login"
          label="Your Email"
          placeholder="Input your email"
          autoFocus
          StartIcon={<EmailOutlined />}
          onKeyPress={onKeyPress}
          sx={inputSx}
          inputProps={{
            inputMode: "email",
          }}
        />
        <PasswordField
          name="password"
          label="Password"
          placeholder="Input your password"
          StartIcon={<LockOpenOutlined />}
          onKeyPress={onKeyPress}
          sx={inputSx}
        />
        <Button
          sx={btnSx}
          disabled={isLoading}
          data-testid="save-login"
          fullWidth
          variant="gradient"
          type="submit"
        >
          Log in
        </Button>
        <Button
          sx={btnSx}
          data-testid="redirect-restore-password"
          fullWidth
          variant="transparent"
          component="a"
          href={environment.links.restorePassword}
        >
          Forgot password
        </Button>
      </AuthFormGrid>
    </LoginForm>
  </>
);

export default Login;
